import React, { createContext, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { stateReducer, mainState } from './reducer';
import { EDIT, LIST, ADD, ACTIVATION } from './constants/views';
import ViewList from './Views/List';
import './_level-system.scss'
import './_level-system.dark-mode.scss'
import ViewEdit from './Views/Edit';
import ViewActivation from './Views/Activation';
import ConfirmLeave from './ConfirmLeave';

export const Context = createContext({});
const LevelSystem = ({ data, access, onSubmit, onHide }) => {
  const [contextState, dispatchContextState] = useReducer(stateReducer, mainState);
  const { view, default_levels, levels } = contextState;
  const [openConfirmLeave, setOpenConfirmLeave] = useState(false);

  const checkChanges = () => {
    isEqual(levels, default_levels) ? onHide() : setOpenConfirmLeave(true)
  }

  const onConfirmLeave = () => {
    setOpenConfirmLeave(false)
    onHide(false)
  }

  const onCancelLeave = () => {
    setOpenConfirmLeave(false)
  }

  return (
    <>
      <Context.Provider value={[{ ...contextState, data, access, onSubmit, onHide: checkChanges }, dispatchContextState]}>
        <ConfirmLeave open={openConfirmLeave} onConfirm={onConfirmLeave} onCancel={onCancelLeave} />
        {(() => {
          switch (view) {
          case LIST:
            return <ViewList />;
          case EDIT:
          case ADD:
            return <ViewEdit />
          case ACTIVATION:
            return <ViewActivation />
          default:
            return null;
          }
        })()}
      </Context.Provider>
    </>
  )
}

LevelSystem.propTypes = {
  data: PropTypes.object,
  access: PropTypes.object,
  onSubmit: PropTypes.func,
  onHide: PropTypes.func,
};

export default LevelSystem;
